import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { AxiosError } from 'axios';

import axiosInstance from '@/configs/axios';

interface PayssionCheckoutProps {
  plan_id: number;
  gateway_id: number;
  coupon: string;
  ref: string;
  click_id?: string;
  pm_id: string;
}

export const checkoutPayssion = createAsyncThunk('appCheckoutPayssion/CheckoutPayssion', async (data: PayssionCheckoutProps) => {
  const body = {
    ...data,
    installments: 1,
  };
  return axiosInstance
    .post('/checkout', body)
    .then((res) => {
      // Os dois campos de campanha são carregados explicitamente porque este thunk entrega
      // `data.data` ao chamador, e eles são top-level no corpo (`campaign-charge-refusal.ts`).
      return { status: res.status, data: res.data?.data, campaign_discount_applied: res.data?.campaign_discount_applied, campaign_discount_refused_reason: res.data?.campaign_discount_refused_reason };
    })
    .catch((err: AxiosError) => {
      // @ts-ignore
      return { status: err.response?.status, data: err.response?.data?.data };
    });
});

export const appCheckoutPayssionSlice = createSlice({
  name: 'appCheckoutPayssion',
  initialState: {
    data: [],
  },
  reducers: {},
});

export default appCheckoutPayssionSlice.reducer;
